import accounting from 'accounting';

function convertNumberFloatToDB(number: string): number {
  return accounting.unformat(number, ',');
}

export default convertNumberFloatToDB;
